<div
  dropdown
  [ngClass]="{ 'nb-dropdown': true, 'btn-group': true, 'full-width': innerOptions.fullWidth }"
  [placement]="innerOptions.placement"
  [autoClose]="innerOptions.autoClose"
  [insideClick]="!innerOptions.closeOnClick"
  [container]="innerOptions.appendToBody ? 'body' : ''"
  [isDisabled]="innerOptions.isDisabled"
>
  <!--
    Built-in dropdown trigger template
    displayed if no <ng-template #triggerTemplate /> found
  -->
  <a dropdownToggle *ngIf="!triggerTemplate">{{ value ? value[innerOptions.labelField] : innerOptions.placeholder }}</a>

  <!-- user defined trigger template -->
  <div dropdownToggle *ngIf="triggerTemplate">
    <ng-container *ngTemplateOutlet="triggerTemplate; context: { selectedItem: value }"></ng-container>
  </div>

  <!--
    Built-in dropdown item template
    displayed if neither <ng-template #itemTemplate />
  -->
  <ng-container *ngIf="!itemTemplate">
    <ul *dropdownMenu class="dropdown-menu w-100">
      <ng-container *ngFor="let item of data | mixAsync">
        <li [ngClass]="innerOptions.itemClass" *ngIf="!item.isDivider" (click)="onItemClick(item)">
          <a title="{{ item[innerOptions.labelField] }}">{{ item[innerOptions.labelField] }}</a>
        </li>
        <div class="dropdown-divider" *ngIf="item.isDivider"></div>
      </ng-container>
    </ul>
  </ng-container>

  <!-- render user defined <ng-template #itemTemplate /> -->
  <ng-container *ngIf="itemTemplate">
    <ul *dropdownMenu class="dropdown-menu w-100">
      <ng-container *ngFor="let item of data | mixAsync; let index = index">
        <li [ngClass]="innerOptions.itemClass" *ngIf="!item.isDivider" (click)="onItemClick(item)">
          <a><ng-container *ngTemplateOutlet="itemTemplate; context: { item: item, index: index }"></ng-container></a>
        </li>
        <div class="dropdown-divider" *ngIf="item.isDivider"></div>
      </ng-container>
    </ul>
  </ng-container>
</div>
